import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { PayloadStates } from '@lore/utils';
import { useConnect } from '@lore/query-connect';
import DialogTemplate from '@/dialogs_common/DialogTemplate';
import { OutlineButton, SolidButton } from '@/components/Button';
import FormTemplate from '@/dialogs_common/FormTemplate';
import Loader from '@/components/Loader';
import DuplicateIconWrapper from '../DuplicateIconWrapper';
import FormTemplateButtonFooter from '@/dialogs_common/FormTemplateButtonFooter';

Start.propTypes = {
  onNext: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  project: PropTypes.object.isRequired
};

export default function Start(props) {
  const {
    onNext,
    onCancel,
    project
  } = props;

  const [timestamp] = useState(new Date().toISOString());

  const params = {
    where: {
      eager: {
        $where: {
          projectId: project.id,
          createdAt: {
            $lt: timestamp
          }
        }
      }
    }
  }

  const activity = useConnect('tag.byId', {
    id: project.data.activityId
  });
  const tagNodes = useConnect('tagNode.find', params, {
    enabled: !!project.id && _.isInteger(project.id)
  });
  const uploads = useConnect('upload.find', params, {
    enabled: !!project.id && _.isInteger(project.id)
  });

  if (
    activity.state === PayloadStates.FETCHING ||
    tagNodes.state === PayloadStates.FETCHING ||
    uploads.state === PayloadStates.FETCHING
  ) {
    return (
      <DialogTemplate>
        <Loader />
      </DialogTemplate>
    )
  }

  function onSubmit() {
    onNext({
      activity,
      tagNodes,
      uploads
    });
  }

  return (
    <DialogTemplate>
      <FormTemplate
        icon={(
          <DuplicateIconWrapper />
        )}
        title="Duplicate Project"
        subtitle={(
          <div className="space-y-2">
            <div>
              Duplicating a project will create a new project and copy over information
              such title and description, as well as subject areas, youth groups, and
              information about your ideal partner (such as their skills and experience).
            </div>
            <div>
              You&apos;ll need to update the project with new dates before we start sharing it
              with potential partners!
            </div>
          </div>
        )}
        onClose={onCancel}
        footer={(
          <FormTemplateButtonFooter>
            <OutlineButton onClick={onCancel}>
              Cancel
            </OutlineButton>
            <SolidButton onClick={onSubmit}>
              Duplicate this Project
            </SolidButton>
          </FormTemplateButtonFooter>
        )}
      />
    </DialogTemplate>
  );
};
